export default __webpack_public_path__ + "static/media/ra-love.b511da18.svg";